var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6875 8.5C19.3281 8.5 18.5688 9.85 18.8781 10.8531L15.55 14.1906C15.2688 14.1062 14.8562 14.1062 14.575 14.1906L12.1844 11.8C12.5031 10.7969 11.7437 9.4375 10.375 9.4375C9.01562 9.4375 8.24687 10.7875 8.56562 11.8L4.29063 16.0656C3.2875 15.7562 1.9375 16.5156 1.9375 17.875C1.9375 18.9062 2.78125 19.75 3.8125 19.75C5.17188 19.75 5.93125 18.4 5.62187 17.3969L9.8875 13.1219C10.1687 13.2063 10.5813 13.2063 10.8625 13.1219L13.2531 15.5125C12.9344 16.5156 13.6938 17.875 15.0625 17.875C16.4219 17.875 17.1906 16.525 16.8719 15.5125L20.2094 12.1844C21.2125 12.4938 22.5625 11.7344 22.5625 10.375C22.5625 9.34375 21.7188 8.5 20.6875 8.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0625 9.4375L15.9437 7.49687L17.875 6.625L15.9437 5.75313L15.0625 3.8125L14.2 5.75313L12.25 6.625L14.2 7.49687L15.0625 9.4375ZM4.28125 11.3125L4.75 9.4375L6.625 8.96875L4.75 8.5L4.28125 6.625L3.8125 8.5L1.9375 8.96875L3.8125 9.4375L4.28125 11.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightIcon);
export default __webpack_public_path__ + "static/media/insight_icon.f7cc299671f95e6018c2d334b51bd5f0.svg";
export { ForwardRef as ReactComponent };